import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["auxiliaryText", "back", "disabled", "label"];
import { ChevronLeft, ChevronRight } from '@resultadosdigitais/tangram-react-icons';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import DropdownCustomItem from './DropdownCustomItem';
import DropdownLabel from './DropdownLabel';
const Root = styled(DropdownCustomItem).withConfig({
  displayName: "DropdownNavigation__Root",
  componentId: "sc-12e27no-0"
})(["display:flex;"]);
const StyledChevronLeft = styled(ChevronLeft).withConfig({
  displayName: "DropdownNavigation__StyledChevronLeft",
  componentId: "sc-12e27no-1"
})(["fill:var(--neutral-icon-low-emphasis);margin-right:var(--size-spacing-02);"]);
const StyledChevronRight = styled(ChevronRight).withConfig({
  displayName: "DropdownNavigation__StyledChevronRight",
  componentId: "sc-12e27no-2"
})(["fill:var(--neutral-icon-low-emphasis);margin-left:var(--size-spacing-02);"]);
const StyledLabelWrapper = styled.div.withConfig({
  displayName: "DropdownNavigation__StyledLabelWrapper",
  componentId: "sc-12e27no-3"
})(["flex:1;min-width:0;"]);
const DropdownNavigation = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      auxiliaryText,
      back,
      disabled,
      label
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    ref: ref,
    disabled: disabled
  }), back && /*#__PURE__*/React.createElement(StyledChevronLeft, {
    title: label
  }), /*#__PURE__*/React.createElement(StyledLabelWrapper, null, /*#__PURE__*/React.createElement(DropdownLabel, {
    label: label,
    auxiliaryText: auxiliaryText
  })), !back && /*#__PURE__*/React.createElement(StyledChevronRight, {
    title: label
  }));
});
DropdownNavigation.displayName = 'DropdownNavigation';
DropdownNavigation.Style = Root;
DropdownNavigation.defaultProps = {
  disabled: false
};
process.env.NODE_ENV !== "production" ? DropdownNavigation.propTypes = {
  /**
   * Sets the auxiliary text.
   */
  auxiliaryText: PropTypes.string,
  /**
   * Disables the `Dropdown.Navigation`.
   */
  disabled: PropTypes.bool,
  /**
   * Sets the label.
   */
  label: PropTypes.string.isRequired
} : void 0;
export default DropdownNavigation;